<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.comment-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('SMS Configuration') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="save">
          <div class="px-4 py-5 sm:p-6">
            <div class="grid grid-cols-3 gap-3">
              <div class="col-span-3">
                <label class="form-label" for="sms_status">{{ $t('Status') }}</label>
                <input-switch
                  :disabled-label="$t('The sms service turned OFF')"
                  :enabled-label="$t('The sms service turned ON')"
                  id="sms_status"
                  v-model="sms.sms_status"
                ></input-switch>
                <div class="form-description-text">
                  {{ $t('This option controls SMS service can be turned ON or OFF in certain cases') }}.
                </div>
              </div>
              <template v-if="sms.sms_status">
                <div class="col-span-3">
                  <label class="form-label" for="sms_channel">{{ $t('SMS channel') }}</label>
                  <div class="pt-1">
                    <select class="form-input bg-white" id="sms_channel" required v-model="sms.sms_channel">
                      <option :value="null" disabled>
                        {{ $t('Select an option') }}
                      </option>
                      <option value="nexmo">{{ $t('Nexmo') }}</option>
                      <option value="twilio">{{ $t('Twilio') }}</option>
                    </select>
                  </div>
                </div>
                <template v-if="sms.sms_channel == 'nexmo'">
                  <div class="col-span-3">
                    <label class="form-label" for="nexmo_key">{{ $t('Nexmo key') }}</label>
                    <div class="pt-1">
                      <input :placeholder="$t('Nexmo key')" class="form-input" id="nexmo_key" required v-model="sms.nexmo_key" />
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label" for="nexmo_secret">{{ $t('Nexmo secret') }}</label>
                    <div class="pt-1">
                      <input
                        :placeholder="$t('Nexmo secret')"
                        type="password"
                        class="form-input"
                        id="nexmo_secret"
                        required
                        v-model="sms.nexmo_secret"
                      />
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label" for="nexmo_from">{{ $t('From') }}</label>
                    <div class="pt-1">
                      <input :placeholder="$t('Nexmo from')" class="form-input" id="nexmo_from" required v-model="sms.nexmo_from" />
                    </div>
                  </div>
                </template>
                <template v-if="sms.sms_channel == 'twilio'">
                  <div class="col-span-3">
                    <label class="form-label" for="twilio_account_sid">{{ $t('Twilio account sid') }}</label>
                    <div class="pt-1">
                      <input
                        :placeholder="$t('Twilio account sid')"
                        class="form-input"
                        id="twilio_account_sid"
                        required
                        v-model="sms.twilio_account_sid"
                      />
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label" for="twilio_auth_token">{{ $t('Twilio auth token') }}</label>
                    <div class="pt-1">
                      <input
                        :placeholder="$t('Twilio auth token')"
                        type="password"
                        class="form-input"
                        id="twilio_auth_token"
                        required
                        v-model="sms.twilio_auth_token"
                      />
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label" for="twilio_from">{{ $t('From') }}</label>
                    <div class="pt-1">
                      <input :placeholder="$t('From')" class="form-input" id="twilio_from" required v-model="sms.twilio_from" />
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'sms',
  data() {
    return {
      loading: true,
      sms: {
        sms_status: false,
        sms_channel: 'nexmo',
        nexmo_key: null,
        nexmo_secret: null,
        nexmo_from: null,
        twilio_account_sid: null,
        twilio_auth_token: null,
        twilio_from: null,
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      axios
        .get(route('settings.get.sms'))
        .then((response) => {
          this.sms = response.data;
          this.loading = false;
        })
        .catch(function () {
          this.$router.push('/admin/settings');
        });
    },
    save() {
      this.loading = true;
      axios
        .post(route('settings.set.sms'), this.sms)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
